import Repository from "../../repository";

export default {
    GetMenuByArea: (payload) => Repository.post(`/api/Guests/MenuPublicAPI/GetMenuByArea`, payload),
    Get: (payload) => Repository.post(`/api/Guests/MenuPublic/Get`, payload),
}
